import React, { useEffect, useState } from 'react';
import { Container, Fade, Slide, Typography } from '@mui/material';
import Button2 from '../../atoms/button2/button2';
import './headboardInforme2024.scss';
import useScreenSize from '../../../hooks/useScreenSize';

export interface IHeadboardInforme2024Props {
    title: string;
    desc: any;
    bgImage: string;
    bgImageMobile: string;
    btnRedirect: string;
    btnLabel: string;
}

const HeadboardInforme2024 = ({
    title,
    desc,
    bgImage,
    bgImageMobile,
    btnRedirect,
    btnLabel,
}: IHeadboardInforme2024Props) => {
    const [showElems, setShowElems] = useState({title: false, desc: false})
    const screenSize = useScreenSize()

    useEffect(() => {
        setTimeout(() => {
            setShowElems(prevState => ({...prevState, title: true}));
        }, 800);
        
        setTimeout(() => {
            setShowElems(prevState => ({...prevState, desc: true}));
        }, 1200);
    }, []);

    return (
        <Fade in timeout={500} appear>
            <div className="o-headboard-informe2024">
                <img
                    src={screenSize < 968 ? bgImageMobile : bgImage}
                    alt=""
                    className="o-headboard-informe2024__bg"
                />
                <Container className="o-headboard-informe2024__container">
                    <Slide in={showElems.title} direction='left'>
                        <Typography
                            variant="h1"
                            dangerouslySetInnerHTML={{
                                __html: title,
                            }}
                            className="o-headboard-informe2024__title"
                        />
                    </Slide>
                    <Slide in={showElems.desc} direction='right'>
                        <div className="o-headboard-informe2024__text">
                            <div className="o-headboard-informe2024__desc">
                                {desc}
                            </div>
                            <Button2
                                label={btnLabel}
                                redirect={btnRedirect}
                                classname="o-headboard-informe2024__btn"
                                rel="referrer follow"
                                target="_self"
                            />
                        </div>
                    </Slide>
                </Container>
            </div>
        </Fade>
    );
};

export default HeadboardInforme2024;
